import Reveal from "@/components/feature/Reveal";
import { clinic } from "@/mocks/clinic";
import { ReserveButton } from "@/components/layout/ReserveButton";
import { LineButton } from "@/components/layout/LineButton";

const heroPortrait =
  "/images/site/sbdc-home-fv-main.png";

export default function FirstView() {
  return (
    <section className="relative overflow-hidden bg-background-50 pt-28 md:pt-36 lg:min-h-[680px] lg:pb-24 lg:pt-40">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-24 top-40 h-72 w-72 rounded-full bg-secondary-200/40 blur-3xl"
      />

      {/* PC（1024px以上）: 人物画像をファーストビューの背景ビジュアルとして扱う。
          固定ヘッダーの裏に入り込まないよう、コンテナ上端をヘッダー高さ分＋明確な余白（約108px）下げる */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 top-[108px] hidden lg:block">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={heroPortrait}
            alt="美容医療のイメージ"
            title="渋谷美容皮膚科クリニック 施術イメージ"
            className="hero-portrait-in h-full w-full object-cover object-[68%_10%]"
            style={{
              animationDelay: "0.35s",
              WebkitMaskImage:
                "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.18) 18%, rgba(0,0,0,0.68) 38%, #000 54%, #000 100%)",
              maskImage:
                "linear-gradient(to right, transparent 0%, rgba(0,0,0,0.18) 18%, rgba(0,0,0,0.68) 38%, #000 54%, #000 100%)",
            }}
          />
          {/* 左側の背景・髪・肩だけをアイボリーへ強めになじませ、コピーの可読性を確保 */}
          <div
            aria-hidden
            className="absolute inset-y-0 left-0 w-[48%] bg-gradient-to-r from-background-50 via-background-50/55 to-transparent"
          />
          {/* 上端を背景へ溶かし「ここから画像」の境界を消す */}
          <div
            aria-hidden
            className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-background-50 to-transparent"
          />
          {/* 下端を次セクションになじませる */}
          <div
            aria-hidden
            className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background-50 to-transparent"
          />
        </div>
      </div>

      <div className="u-container relative z-10">
        <div className="flex flex-col lg:max-w-[51%] lg:pt-4">
          {/* copy */}
          <div className="order-1">
            <Reveal>
              <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">
                SHIBUYA BEAUTY DERMATOLOGY CLINIC
              </span>
            </Reveal>
            <Reveal delay={120}>
              <h1 className="mt-7 whitespace-pre-line font-heading text-[30px] leading-[1.55] tracking-[0.02em] text-foreground-950 md:text-[42px] lg:whitespace-pre lg:text-[clamp(32px,2.9vw,40px)]">
                {"自分に自信を持つために、\n美容医療という選択を。"}
              </h1>
            </Reveal>
            <Reveal delay={220}>
              <span className="mt-8 block h-px w-14 bg-accent-500" />
              <p className="mt-7 max-w-md whitespace-pre-line text-[14px] leading-[2.1] text-foreground-700 md:text-[15px]">
                {"一人ひとりの悩みに寄り添い、\n納得できる美容医療をご提案します。"}
              </p>
            </Reveal>
          </div>

          {/* スマホ〜タブレット: コピー → 人物画像 → CTA の縦順を維持しつつ、画像は独立BOXに見せない */}
          <div className="order-2 mt-10 lg:hidden">
            {/* フルブリードに広げて背景とつなげる */}
            <div className="relative -mx-6 h-[520px] overflow-hidden md:-mx-10 md:h-[560px]">
              <img
                src={heroPortrait}
                alt="美容医療のイメージ"
                title="渋谷美容皮膚科クリニック 施術イメージ"
                className="hero-portrait-in h-full w-full object-cover object-[70%_12%] md:object-[center_18%]"
                style={{ animationDelay: "0.2s" }}
              />
              {/* 上端をファーストビュー背景になじませる */}
              <div
                aria-hidden
                className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-background-50 via-background-50/70 to-transparent"
              />
              {/* 下端を次セクションへ自然につなぐ縦方向グラデーション（画像下端の約22%） */}
              <div
                aria-hidden
                className="absolute inset-x-0 bottom-0 h-[22%] bg-gradient-to-t from-background-50 via-background-50/75 to-transparent"
              />
            </div>
          </div>

          {/* cta */}
          <div className="order-3 mt-9 lg:mt-12">
            <Reveal delay={280}>
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                <ReserveButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-8 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700">
                  <i className="ri-calendar-check-line text-base" aria-hidden />
                  WEB予約
                </ReserveButton>
                <LineButton className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 bg-background-50 px-8 py-3.5 text-[14px] font-medium text-foreground-900 transition-colors hover:bg-background-100">
                  <i className="ri-line-fill text-base" aria-hidden />
                  LINEで相談
                </LineButton>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3 text-[12px] text-foreground-700 md:text-[13px]">
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-700" aria-hidden />
                  渋谷駅近く
                </span>
                <span className="hidden h-4 w-px bg-foreground-950/15 sm:block" />
                <span className="flex items-center gap-2">
                  <i className="ri-time-line text-accent-700" aria-hidden />
                  診療時間 {clinic.hours}
                </span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}